import React, { useState, useEffect } from 'react';
import ModalButtonLink from '../general/ModalButtonLink';
import ReactDOM from 'react-dom';
import DealerLocator from './DealerLocator.jsx';
import { ExpandedModalContainer, StyledChildrenContainer, ModalBackDrop } from '../general/Styles.jsx';
import useDataFromDom from '../../hooks/useDataFromDom';

export interface DealerLocatorPDPDomData {
  site?: string;
  buttonText?: string;
}

const Portal: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const modalRoot = document.getElementById('dealer-portal-pdp-modal');
  return modalRoot ? ReactDOM.createPortal(children, modalRoot) : null;
};

const DealerLocatorPDP: React.FC = () => {
  const [results, setResults] = useState(false);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);

  const { site, buttonText }: DealerLocatorPDPDomData = useDataFromDom(['data-react'], 'dealer-locator-react-data');

  const open = () => {
    setError(false);
    setResults([]);
    setModal(true);
    setLoading(false);
  };

  const close = () => {
    setModal(false);
  };

  useEffect(() => {
    if(modal) {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'auto'
       });
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      document.body.classList.add('react-modal-open');
      document.body.addEventListener('click', function(e) { 
        if((e.target as HTMLElement).id === 'react-outer-modal'){
          setModal(false);
        }
      }, false);
    }
    else {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      document.body.classList.remove('react-modal-open');
    }
},[modal])

  return (
    <>
     { modal ?
     <Portal>
        <ExpandedModalContainer id="react-outer-modal">
            <ModalBackDrop onClick={close} />
            <StyledChildrenContainer id="react-inner-modal">
              <div className="react-modal-close" onClick={close}></div>
              <DealerLocator page={'pdp'} />
            </StyledChildrenContainer>
        </ExpandedModalContainer>
      </Portal>
     : <ModalButtonLink id="react-modal-button" classx="react-modal" open={open} text={buttonText} theme={site ? site : 'null'} />
     }
    </>
  );
};

export default DealerLocatorPDP;
